import { schema } from 'normalizr'
import {
  createEntitiesSelector,
  createSelectorForEntityKey,
  actionCrudCreatorsFor,
  getEntity,
} from '@infotech/lib-api-middleware'
import { ESUZ_CORE_URL } from './constants'

export const ESUZ_USERS_SCHEMA_NAME = `esuzUsers`
export const URL = `${ESUZ_CORE_URL}/users/`

const esuzUsersSchema = new schema.Entity(ESUZ_USERS_SCHEMA_NAME)
export const esuzUsersSelector = createSelectorForEntityKey(ESUZ_USERS_SCHEMA_NAME)
export const esuzUsersEntitiesSelector = createEntitiesSelector(ESUZ_USERS_SCHEMA_NAME)
export const esuzUsersApiActions = actionCrudCreatorsFor(ESUZ_USERS_SCHEMA_NAME, URL, esuzUsersSchema)
export const singleEsuzUserselector = (state, id) => getEntity(state, ESUZ_USERS_SCHEMA_NAME, id)

export const esuzUsersApiActionsGenerator = actionCrudCreatorsFor(ESUZ_USERS_SCHEMA_NAME, `${URL}one/`, esuzUsersSchema)
